/* eslint-disable jsx-a11y/anchor-is-valid */
import { MenuComponent } from '_metronic/assets/ts/components'
import { Fragment, useEffect } from 'react'
import { KTSVG } from '_metronic/helpers'

interface Props {
  onDeleteAll: () => void
}

const ActionAllButton: React.FC<Props> = ({ onDeleteAll }) => {
  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  return (
    <Fragment>
      <a
        className='btn btn-sm btn-light-primary fw-bold me-4'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'>
        Action All
        <KTSVG path='/media/icons/duotune/general/gen024.svg' svgClassName='svg-icon-1' />
      </a>

      <div
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-250px py-4'
        data-kt-menu='true'>
        <div className='menu-item px-3' data-kt-menu-dismiss='true'>
          <a
            className='menu-link px-3'
            onClick={() => {
              onDeleteAll()
            }}>
            <div className='d-flex flex-row align-items-center'>
              <KTSVG
                path='/media/icons/duotune/general/gen027.svg'
                svgClassName='svg-icon-2 me-3'
                className='text-kumopack-danger'
              />
              <div className='text-kumopack-grey-700' style={{ marginTop: '0.1rem' }}>
                ลบที่เลือก
              </div>
            </div>
          </a>
        </div>
      </div>
    </Fragment>
  )
}

export default ActionAllButton
